import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/main/src/features/openlecture/list/OpenLectureListFeature.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/main/src/features/openlecture/OpenLectureListLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/sub/ui/src/layout/MainLayout/MainLayout.tsx");
